"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ic_perm_device_information_white_48px = _interopRequireDefault(require("../../img/ic_perm_device_information_white_48px.svg"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobileLandscapeMessage = function MobileLandscapeMessage() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mobile-landscape-message-container"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
    src: _ic_perm_device_information_white_48px.default,
    alt: "portrait icon"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "mobile-landscape-message-title"
  }, "For the best experience, please view in Portrait mode"), /*#__PURE__*/_react.default.createElement("div", {
    className: "mobile-landscape-message-subtitle"
  }, "Thanks for understanding!"));
};

var _default = MobileLandscapeMessage;
exports.default = _default;